class CreateInvoiceFromBidController {
    constructor(bidToUse, $http, $uibModalInstance, InvoiceTemplate) {
        this.api = $http;
        this.bidToUse = bidToUse;
        this.modalInstance = $uibModalInstance;
        this.invoiceTemplateModel = InvoiceTemplate;

        this.invoiceTemplates = [];
        this.dataToSend = {
            extended: {
                invoice_date: new Date(),
                address: bidToUse.address,
                processing_costs_general: bidToUse.processing_costs_general,
                processing_costs_per_person: bidToUse.processing_costs_per_person,
                tax_rate: bidToUse.tax_rate
            }
        };

        this.submitting = false;

        this.loadInvoiceTemplates();
    }

    submit() {
        this.submitting = true;
        this.api.post('billing/invoices/' + this.bidToUse.id + '/to-invoice', this.dataToSend).then((response) => {
            this.close({
                 status: 'success',
                invoice: response.data.data
            })
        }, () => {
            this.close({
                status: 'error'
            })
        });
    }

    loadInvoiceTemplates() {
        this.invoiceTemplates = [];
        this.invoiceTemplateModel.getList().then((collection) => {
            _.forEach(collection, (v, k) => {
                if (v['enable_for_invoice']) {
                    this.invoiceTemplates.push(v.plain());
                }
            });

            this.dataToSend.invoice_template_id = this.invoiceTemplates[0].id;
        });
    }

    close(data) {
        this.modalInstance.close(data);
    }

    cancel() {
        this.modalInstance.dismiss();
    }
}

CreateInvoiceFromBidController.$inject = [
    'bidToUse',
    '$http',
    '$uibModalInstance',
    'InvoiceTemplate',
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:CreateInvoiceFromBidController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('CreateInvoiceFromBidController', CreateInvoiceFromBidController);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/modals/create-invoice-from-bid-controller.js